// Hard-coded list of named banks active in scope=1, shared by the three
// comparison tabs (Bilalder, Alder, Lånebeløp).
// The org_nrs match the BANK_CODES dict in analytics-api/app/crud/bruktbilfinansiering.py.
//
// Use the CANONICAL org_nr. DNB's loans are booked on 816521432; 984851006 is
// only an OrganizationAlias and matches zero rows in mv_bbf_transfers.
// 911629283 is AS Financiering — a separate lender from Brage Finans (995610760).
export interface KnownBank {
  org_nr: string
  name: string
}

export const KNOWN_BANKS: KnownBank[] = [
  { org_nr: '816521432', name: 'DNB' },
  { org_nr: '983521592', name: 'Santander' },
  { org_nr: '924507500', name: 'Nordea' },
  { org_nr: '992873183', name: 'Volkswagen Finans' },
  { org_nr: '978690920', name: 'Toyota Financial Services' },
  { org_nr: '981060113', name: 'BMW Financial Services' },
  { org_nr: '995610760', name: 'Brage Finans' },
  { org_nr: '911629283', name: 'AS Financiering' },
  { org_nr: '930050237', name: 'SpareBank 1 Nord' },
  { org_nr: '975963748', name: 'SpareBank 1 Østlandet' },
  { org_nr: '938521549', name: 'SpareBank 1 Midt' },
]
